import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import Dialog from "react-bootstrap-dialog";
import {
  get_smtp_setting_details,
  add_smtp,
  delete_smtp
} from "../../../redux/actions/emailActions";
import {aclUtil} from "../../util"

const HorizontalLine = ({}) => <hr />;

let isLoading = false;
class EmailSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'EMAIL_SETTING',
      path: ["Home","Email Settings"],
      links: ["home",'emailSetting'],
      msgType: "",
      alertMessage: "",
      show: "",
      transaction_email_address: "",
      campaign_email_address: "",
      smtp: "disable",
      campaign_smtp: "disable",
      hostname: "",
      campaign_hostname: "",
      authentication: "yes",
      username: "",
      password: "",
      encryption: "TLS",
      port: "",
      campaign_authentication: "yes",
      campaign_username: "",
      campaign_password: "",
      campaign_encryption: "TLS",
      campaign_port: "",
      usernameError: "",
      passwordError: "",
      portError: "",
      hostnameError: "",
      smtpid: "",
      campaign_usernameError: "",
      campaign_passwordError: "",
      campaign_portError: "",
      campaign_hostnameError: "",
      smtpid: "",
      voucher_expiration_reminder: 'enable',
      voucher_expiration_reminder_day: 0,
      reviews_switch: 'enable',
      question_switch: 'enable',
      merchant_sales_emails: 'enable',
      popup_subscrbe: 'enable',
      vouchers_email: 'enable',

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleChange(e) {
    if (this.state.msgType !== "" && this.state.alertMessage !== "") {
      this.props.clearAlert();
    }
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleDelete = event => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.props.delete_smtp();
        })
      ]
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.smtp === "enable") {
      if (this.state.hostname.length === 0) {
        isError = true;
        this.setState({ hostnameError: "red" });
      }
      if (this.state.username.length === 0) {
        isError = true;
        this.setState({ usernameError: "red" });
      }
      if (this.state.password.length === 0) {
        isError = true;
        this.setState({ passwordError: "red" });
      }
      if (this.state.port.length === 0) {
        isError = true;
        this.setState({ portError: "red" });
      }
    }
    if (this.state.campaign_smtp === "enable") {
      if (this.state.campaign_hostname.length === 0) {
        isError = true;
        this.setState({ campaign_hostnameError: "red" });
      }
      if (this.state.campaign_username.length === 0) {
        isError = true;
        this.setState({ campaign_usernameError: "red" });
      }
      if (this.state.campaign_password.length === 0) {
        isError = true;
        this.setState({ campaign_passwordError: "red" });
      }
      if (this.state.campaign_port.length === 0) {
        isError = true;
        this.setState({ campaign_portError: "red" });
      }
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    this.setState({ show: true });
    if (!err) {
      const addData = {
        smtp: this.state.smtp,
        hostname: this.state.hostname,
        authentication: this.state.authentication,
        username: this.state.username,
        password: this.state.password,
        encryption: this.state.encryption,
        port: this.state.port,
        campaign_smtp: this.state.campaign_smtp,
        campaign_hostname: this.state.campaign_hostname,
        campaign_authentication: this.state.campaign_authentication,
        campaign_username: this.state.campaign_username,
        campaign_password: this.state.campaign_password,
        campaign_encryption: this.state.campaign_encryption,
        campaign_port: this.state.campaign_port,
        transaction_email_address: this.state.transaction_email_address,
        campaign_email_address: this.state.campaign_email_address,
        voucher_expiration_reminder: this.state.voucher_expiration_reminder,
        voucher_expiration_reminder_day : this.state.voucher_expiration_reminder_day,
        reviews_switch: this.state.reviews_switch,
        question_switch: this.state.question_switch,
        merchant_sales_emails: this.state.merchant_sales_emails,
        popup_subscrbe: this.state.popup_subscrbe,
        vouchers_email: this.state.vouchers_email,
      };
      this.props.add_smtp(addData);
      window.scrollTo(0, 0);
    }
  }

  componentWillMount() {
    this.props.get_smtp_setting_details();
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    
    if (
      this.props.smtpDetails !== nextProps.smtpDetails &&
      !isEmpty(nextProps.smtpDetails)
    ) {
      const portConst =
        nextProps.smtpDetails.port == null ? "" : nextProps.smtpDetails.port;
      const hostnameConst =
        nextProps.smtpDetails.hostname == null
          ? ""
          : nextProps.smtpDetails.hostname;
      const usernameConst =
        nextProps.smtpDetails.username == null
          ? ""
          : nextProps.smtpDetails.username;
      const passwordConst =
        nextProps.smtpDetails.password == null
          ? ""
          : nextProps.smtpDetails.password;
      this.setState({
        smtpid: nextProps.smtpDetails.smtpid,
        port: portConst,
        smtp: (nextProps.smtpDetails.smtp) ? nextProps.smtpDetails.smtp : 'disable',
        hostname: hostnameConst,
        authentication: (nextProps.smtpDetails.authentication) ? nextProps.smtpDetails.authentication : 'yes',
        username: usernameConst,
        password: passwordConst,
        encryption: (nextProps.smtpDetails.encryption) ? nextProps.smtpDetails.encryption : 'TLS',
        campaign_port: (nextProps.smtpDetails.campaign_port) ? nextProps.smtpDetails.campaign_port : '',
        campaign_smtp: (nextProps.smtpDetails.campaign_smtp) ? nextProps.smtpDetails.campaign_smtp : 'disable',
        campaign_hostname: (nextProps.smtpDetails.campaign_hostname) ? nextProps.smtpDetails.campaign_hostname : '',
        campaign_authentication: (nextProps.smtpDetails.campaign_authentication) ? nextProps.smtpDetails.campaign_authentication : 'yes',
        campaign_username: (nextProps.smtpDetails.campaign_username) ? nextProps.smtpDetails.campaign_username : '',
        campaign_password: (nextProps.smtpDetails.campaign_password) ? nextProps.smtpDetails.campaign_password : '',
        campaign_encryption: (nextProps.smtpDetails.campaign_encryption) ? nextProps.smtpDetails.campaign_encryption : 'TLS',
        transaction_email_address: nextProps.smtpDetails.transaction_email_address,
        campaign_email_address: nextProps.smtpDetails.campaign_email_address,
        voucher_expiration_reminder: nextProps.smtpDetails.voucher_expiration_reminder,
        voucher_expiration_reminder_day : nextProps.smtpDetails.voucher_expiration_reminder_day,
        reviews_switch: nextProps.smtpDetails.reviews_switch,
        question_switch: nextProps.smtpDetails.question_switch,
        merchant_sales_emails: nextProps.smtpDetails.merchant_sales_emails,
        popup_subscrbe: nextProps.smtpDetails.popup_subscrbe,
        vouchers_email: nextProps.smtpDetails.vouchers_email,
      });
    }
    if (this.props.deletedSmtp !== nextProps.deletedSmtp) {
      this.handleShow();
      this.props.renderAlert("danger", nextProps.deletedSmtp.message);
      this.setState({
        msgType: "",
        alertMessage: "",
        show: "",
        smtp: "disable",
        hostname: "",
        authentication: "yes",
        username: "",
        password: "",
        encryption: "TLS",
        port: "",
        usernameError: "",
        passwordError: "",
        portError: "",
        hostnameError: "",
        campaign_smtp: "disable",
        campaign_hostname: "",
        campaign_authentication: "yes",
        campaign_username: "",
        campaign_password: "",
        campaign_encryption: "TLS",
        campaign_port: "",
        campaign_usernameError: "",
        campaign_passwordError: "",
        campaign_portError: "",
        campaign_hostnameError: "",
        smtpid: ""
      });
      window.scrollTo(0, 0);
    }
    if (this.props.updatedsmtp !== nextProps.updatedsmtp) {
      this.handleShow();
      this.props.renderAlert("success", nextProps.updatedsmtp.message);
      isLoading = false;
      this.props.get_smtp_setting_details();
      window.scrollTo(0, 0);
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
      isLoading = false;
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div className="col-lg-12 email-setting">
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {this.state.isLoading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          {this.state.show &&
            this.state.alertMessage !== "" &&
            this.state.msgType && (
              <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <form onSubmit={this.handleSubmit}>
            <header className="panel-heading">Company Email Lists</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicTranxFromText">
                    <ControlLabel>Transaction From Email</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.transaction_email_address}
                      placeholder="Transaction From Email"
                      onChange={this.handleChange}
                      name="transaction_email_address"
                    />
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicCampFromText">
                    <ControlLabel>Campaign From Email</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.campaign_email_address}
                      placeholder="Campaign From Email"
                      onChange={this.handleChange}
                      name="campaign_email_address"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <header className="panel-heading">Transaction Email SMTP Settings</header>
            <div className="panel-body">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="smtp">
                      <ControlLabel> SMTP </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="smtp"
                        onChange={this.handleChange}
                        value={this.state.smtp}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="username">
                      <ControlLabel>
                        {(this.state.smtpid === "" ||
                          this.state.username === "") &&
                          this.state.smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        User Name{" "}
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.username}
                        placeholder="User Name"
                        onChange={this.handleChange}
                        name="username"
                        style={{ borderColor: this.state.usernameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="authentication">
                      <ControlLabel> Authentication </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="authentication"
                        onChange={this.handleChange}
                        value={this.state.authentication}
                      >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="port">
                      <ControlLabel>
                        {(this.state.smtpid === "" || this.state.port === "") &&
                          this.state.smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        Port{" "}
                      </ControlLabel>
                      <FormControl
                        type="number"
                        value={this.state.port}
                        placeholder="Port"
                        onChange={this.handleChange}
                        name="port"
                        style={{ borderColor: this.state.portError }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="hostname">
                      <ControlLabel>
                        {(this.state.smtpid === "" ||
                          this.state.hostname === "") &&
                          this.state.smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        Hostname{" "}
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.hostname}
                        placeholder="Hostname"
                        onChange={this.handleChange}
                        name="hostname"
                        style={{ borderColor: this.state.hostnameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="password">
                      <ControlLabel>
                        {(this.state.smtpid === "" ||
                          this.state.password === "") &&
                          this.state.smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        Password{" "}
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.password}
                        placeholder="Password"
                        onChange={this.handleChange}
                        name="password"
                        style={{ borderColor: this.state.passwordError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="encryption">
                      <ControlLabel> Encryption </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="encryption"
                        onChange={this.handleChange}
                        value={this.state.encryption}
                      >
                        <option value="TLS">TLS</option>
                        <option value="SSL">SSL</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <HorizontalLine />
                </Row>
              </div>
            </div>
            <header className="panel-heading">Campaign Email SMTP Settings</header>
            <div className="panel-body">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="campaign_smtp">
                      <ControlLabel> SMTP </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="campaign_smtp"
                        onChange={this.handleChange}
                        value={this.state.campaign_smtp}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="campaign_username">
                      <ControlLabel>
                        {(this.state.smtpid === "" ||
                          this.state.campaign_username === "") &&
                          this.state.campaign_smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        User Name{" "}
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.campaign_username}
                        placeholder="User Name"
                        onChange={this.handleChange}
                        name="campaign_username"
                        style={{ borderColor: this.state.campaign_usernameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="campaign_authentication">
                      <ControlLabel> Authentication </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="campaign_authentication"
                        onChange={this.handleChange}
                        value={this.state.campaign_authentication}
                      >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="campaign_port">
                      <ControlLabel>
                        {(this.state.smtpid === "" || this.state.campaign_port === "") &&
                          this.state.campaign_smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        Port{" "}
                      </ControlLabel>
                      <FormControl
                        type="number"
                        value={this.state.campaign_port}
                        placeholder="Port"
                        onChange={this.handleChange}
                        name="campaign_port"
                        style={{ borderColor: this.state.campaign_portError }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="campaign_hostname">
                      <ControlLabel>
                        {(this.state.smtpid === "" ||
                          this.state.campaign_hostname === "") &&
                          this.state.campaign_smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        Hostname{" "}
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.campaign_hostname}
                        placeholder="Hostname"
                        onChange={this.handleChange}
                        name="campaign_hostname"
                        style={{ borderColor: this.state.campaign_hostnameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="campaign_password">
                      <ControlLabel>
                        {(this.state.smtpid === "" ||
                          this.state.campaign_password === "") &&
                          this.state.campaign_smtp === "enable" && (
                            <span style={{ color: "red" }}>*</span>
                          )}{" "}
                        Password{" "}
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.campaign_password}
                        placeholder="Password"
                        onChange={this.handleChange}
                        name="campaign_password"
                        style={{ borderColor: this.state.campaign_passwordError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="campaign_encryption">
                      <ControlLabel> Encryption </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="campaign_encryption"
                        onChange={this.handleChange}
                        value={this.state.campaign_encryption}
                      >
                        <option value="TLS">TLS</option>
                        <option value="SSL">SSL</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <HorizontalLine />
                </Row>
              </div>
            </div>
            <header className="panel-heading">Other Setting</header>
            <div className="panel-body">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="question_switch">
                      <ControlLabel>Activate Questions on all Offers</ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="question_switch"
                        onChange={this.handleChange}
                        value={this.state.question_switch}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="vouchers_email">
                      <ControlLabel>Order/Voucher Emails</ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="vouchers_email"
                        onChange={this.handleChange}
                        value={this.state.vouchers_email}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="merchant_sales_emails">
                      <ControlLabel>Merchant Sales Emails</ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="merchant_sales_emails"
                        onChange={this.handleChange}
                        value={this.state.merchant_sales_emails}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>

                    <FormGroup controlId="popup_subscrbe">
                      <ControlLabel>Display Subscribe Form</ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="popup_subscrbe"
                        onChange={this.handleChange}
                        value={this.state.popup_subscrbe}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>

                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="reviews_switch">
                      <ControlLabel> Turn On / Off the Review Tab on your Offers. </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="reviews_switch"
                        onChange={this.handleChange}
                        value={this.state.reviews_switch}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Voucher Expiration Reminder Emails</ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="voucher_expiration_reminder"
                        onChange={this.handleChange}
                        value={this.state.voucher_expiration_reminder}
                      >
                        <option value="enable">Enable</option>
                        <option value="disable">Disable</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup>
                      {this.state.voucher_expiration_reminder == 'enable' && (
                      <React.Fragment>
                      <ControlLabel>Number of days before Expiration Date to send reminder email</ControlLabel>
                      <FormControl
                        type="number"
                        value={this.state.voucher_expiration_reminder_day}
                        placeholder="Enter Number Of Days"
                        onChange={this.handleChange}
                        name="voucher_expiration_reminder_day"
                      />
                      </React.Fragment>
                      )}
                    </FormGroup>
                  </Col>
                  <HorizontalLine />
                </Row>
                <Row className="BtnRow">
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="info"
                      type="submit"
                      id="save-button"
                      disabled={this.props.updating}
                    >
                      Save
                    </Button>
                    <Button
                      bsStyle="danger"
                      type="button"
                      id="delete-button"
                      disabled={this.state.smtpid ? false : true}
                      onClick={this.handleDelete}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

EmailSetting.propTypes = {
  get_smtp_setting_details: PropTypes.func.isRequired,
  add_smtp: PropTypes.func.isRequired,
  delete_smtp: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  updating: state.emailReducer.updating,
  smtpDetails: state.emailReducer.smtpDetails,
  error: state.emailReducer.error,
  updatedsmtp: state.emailReducer.updatedsmtp,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  deletedSmtp: state.emailReducer.deletedSmtp
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    delete_smtp,
    get_smtp_setting_details,
    add_smtp,
    clearAlert,
    renderAlert
  })
)(EmailSetting);



// WEBPACK FOOTER //
// ./src/app/views/admin/emailSetting/EmailSetting.js